import { Component, Input, forwardRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';

@Component({
    selector: 'app-checkbox',
    standalone: true,
    imports: [CommonModule, FormsModule],
    templateUrl: './app-checkbox.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AppCheckbox),
            multi: true
        }
    ]
})
export class AppCheckbox implements ControlValueAccessor {
    @Input() label: string = '';
    @Input() id: string = 'checkbox-' + Math.random().toString(36).substring(2, 9);
    @Input() size: 'xs' | 'sm' | 'md' | 'lg' = 'md';
    @Input() shape: 'square' | 'rounded' = 'square';

    value: boolean = false;
    disabled = false;

    onChange: any = () => { };
    onTouched: any = () => { };

    writeValue(value: any): void {
        this.value = !!value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onToggle() {
        if (this.disabled) return;
        this.value = !this.value;
        this.onChange(this.value);
        this.onTouched();
    }

    get boxSizeClasses(): string {
        const map: Record<string, string> = {
            xs: 'w-3.5 h-3.5',
            sm: 'w-4 h-4',
            md: 'w-5 h-5',
            lg: 'w-6 h-6',
        };
        return map[this.size] ?? map['md'];
    }

    get checkSizeClasses(): string {
        const map: Record<string, string> = {
            xs: 'w-2 h-2 left-[3px]',
            sm: 'w-2.5 h-2.5 left-[3px]',
            md: 'w-3 h-3 left-[4px]',
            lg: 'w-3.5 h-3.5 left-[5px]',
        };
        return map[this.size] ?? map['md'];
    }

    get labelSizeClasses(): string {
        const map: Record<string, string> = {
            xs: 'text-[9px]',
            sm: 'text-[10px]',
            md: 'text-xs',
            lg: 'text-sm',
        };
        return map[this.size] ?? map['md'];
    }

    get shapeClass(): string {
        return this.shape === 'rounded' ? 'rounded-full' : 'rounded-md';
    }
}
